<template>
  <div class="">
    <section>
      <nav class="relative py-8 px-4 xl:px-10 bg-blue-800">
        <div class="flex justify-between items-center">
          <a class="text-xl text-white font-semibold" href="#">
            <img
              class="h-10"
              :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}`"
              alt=""
              width="auto"
            />
          </a>
          <div class="lg:hidden">
            <button @click="showMobileNav=!showMobileNav" class="navbar-burger flex items-center p-3 rounded">
              <svg
                class="text-white block h-4 w-4"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
              >
                <title>Mobile menu</title>
                <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"></path>
              </svg>
            </button>
          </div>
          <ul
            class="hidden absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 lg:flex lg:w-auto lg:space-x-10"
          >
            <li v-for="(p, i) in pages" :key="i" :class="{'group relative dropdown': getSub(p).length>0}">
              <router-link class="text-white font-semibold hover:text-blue-50" 
                :to="({name: $store.state.app.activeGroup.publicPage.route, params: {id: p.id, cid: 0} })">{{p.task}}</router-link>
              <div class="group-hover:block dropdown-menu absolute hidden h-auto pt-3 bg-blue-800">
                <ul v-if="getSub(p).length">
                  <li  v-for="(s,i) in getSub(p)" :key="i">
                    <a v-if="s.locTypeCode=='link'" :href="s.taskEn" target="_blank">
                      {{s.task}}
                    </a>
                    <router-link class="text-white font-semibold mb-3"
                    v-else
                      
                      :to="({name: $store.state.app.activeGroup.publicPage.route, params: {id: s.id, cid: 0} })"
                    >
                      {{s.task}}
                    </router-link>
                  </li>
                </ul>
              </div>
            </li>
            
          </ul>
          <div class="hidden lg:block">
            <router-link
              class="inline-block py-3 px-8 text-sm text-white hover:text-blue-50 uppercase font-semibold border-2 border-white"
              to="/login"
              >Нэвтрэх</router-link
            >
          </div>
        </div>
      </nav>
      <div
        class="relative py-32 text-center bg-cover overflow-hidden"
        :style="`background-image: url('${myResBaseUrl}bendis-assets/images/red-image.png');`"
      >
        <div
          class="absolute top-0 bottom-0 -left-1/4 -right-1/4 flex items-center justify-center"
        >
          <h2 class="stroke opacity-75">BE BOLD</h2>
        </div>
        <div class="relative max-w-4xl mx-auto px-4">
          <span class="text-lg text-white font-semibold uppercase"
            >Develop your skill</span
          >
          <h2
            class="mt-8 mb-8 text-white text-4xl lg:text-6xl font-bold uppercase"
          >
            Take care of your performance every day.
          </h2>
          <a
            class="inline-block w-full md:w-auto px-8 py-5 text-sm font-bold uppercase bg-yellow-500 hover:bg-yellow-400 transition duration-200"
            href="#"
            >Get started free</a
          >
        </div>
      </div>
      <div class="container px-4 py-10 mx-auto">
        <div class="flex flex-wrap items-center justify-center -mx-2 -mb-12">
          <div class="w-1/2 md:w-1/3 lg:w-1/5 px-2 mb-12">
            <img
              class="mx-auto h-6"
              :src="`${myResBaseUrl}bendis-assets/logos/slack.svg`"
              alt=""
            />
          </div>
          <div class="w-1/2 md:w-1/3 lg:w-1/5 px-2 mb-12">
            <img
              class="mx-auto h-6"
              :src="`${myResBaseUrl}bendis-assets/logos/dropbox.svg`"
              alt=""
            />
          </div>
          <div class="w-1/2 md:w-1/3 lg:w-1/5 px-2 mb-12">
            <img
              class="mx-auto h-6"
              :src="`${myResBaseUrl}bendis-assets/logos/spotify.svg`"
              alt=""
            />
          </div>
          <div class="w-1/2 md:w-1/3 lg:w-1/5 px-2 mb-12">
            <img
              class="mx-auto h-6"
              :src="`${myResBaseUrl}bendis-assets/logos/stripe.svg`"
              alt=""
            />
          </div>
          <div class="w-1/2 md:w-1/3 lg:w-1/5 px-2 mb-12">
            <img
              class="mx-auto h-6"
              :src="`${myResBaseUrl}bendis-assets/logos/netflix.svg`"
              alt=""
            />
          </div>
        </div>
      </div>
      <div :class="{'hidden': !showMobileNav}"
        class="navbar-menu fixed top-0 left-0 bottom-0 w-5/6 max-w-sm z-50"
      >
        <div @click="showMobileNav=false" class="navbar-backdrop fixed inset-0 bg-blue-800 opacity-90"></div>
        <nav
          class="relative flex flex-col py-8 w-full h-full bg-white border-r overflow-y-auto"
        >
          <div class="flex items-center mb-16 pr-6">
            <a
              class="ml-16 mr-auto text-xl text-blue-800 font-semibold leading-none"
              href="#"
            >
              <img
                class="h-7"
                :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}`"
                alt=""
                width="auto"
              />
            </a>
          </div>
          <div>
            <ul>
              <li class="mb-1" v-for="(p, i) in pages" :key="i">
                <a
                  class="block pl-16 py-5 font-semibold text-blue-800 hover:bg-blue-50 rounded"
                  href="#"
                  >{{p.task}}</a
                >
              </li>
            </ul>
          </div>
          <div class="mt-auto px-10">
            <div class="pt-6">
              <a
                class="block py-4 text-center text-blue-800 leading-normal uppercase border-2 border-blue-800 hover:bg-blue-50 font-semibold"
                href="#"
                >Нэвтрэх</a
              >
            </div>
            <p class="mt-6 mb-4 text-sm text-center text-blue-400">
              <span
                >© 2022 All rights reserved © GoSmart TM</span
              >
            </p>
          </div>
        </nav>
      </div>
    </section>
    <!-- <header id="header" class="navbar navbar-header">
      <a id="mainMenuOpen" class="burger-menu " @click="mainMenuOpen">
        <feather type="menu"></feather> 
        <div class="df-logo d-flex align-items-center">
          <img    :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}`" alt class="mg-l-10" style="max-width: 40px" />  <span class="mg-l-5 ">{{$store.state.app.activeGroup.name | stripHtml}}</span>
        </div>
      </a>
      
      <div class="navbar-menu-wrapper">
        <div v-if="$store.state.app.isMobile" class="navbar-menu-header">
          <router-link
            :to="({name: $store.state.app.activeGroup.publicPage.route, params: {id: $store.state.app.homePageId, cid: 0 } })"
            class="mg-r-10 df-logo"
          >
            <img    :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}`" alt class style="max-width: 40px" />
            <span class="mg-l-5">{{$store.state.app.activeGroup.name | stripHtml}}</span>
          </router-link>
        </div>
        <div v-else class="navbar-brand">
          <router-link
            :to="({name: $store.state.app.activeGroup.publicPage.route, params: {id: $store.state.app.homePageId, cid: 0 } })"
            class="mg-r-10"
          >
            <img   
              :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}`"
              alt
              class="df-logo"
              style="max-width: 40px"
            />
          </router-link>
          <h1 style="font-size: 1.1rem" class="d-none d-xl-block">
            <router-link
              :to="({name: $store.state.app.activeGroup.publicPage.route, params: {id: $store.state.app.homePageId, cid: 0 } })"
              v-html="$store.state.app.activeGroup.name"
              class="df-logo logo tx-16"
              style="line-height: 1.1"
            ></router-link>
          </h1>
        </div>

        <ul id="navbarMenu" class="nav navbar-menu order-2 pd-l-30" style="max-width:1080px">
          <li class="nav-label pd-l-20 pd-lg-l-25 d-lg-none">Үндсэн цэс</li>
          <li
            class="nav-item"
            v-for="(p,i) in pages"
            :key="i"
            :class="{'with-sub': getSub(p).length, 'show': activeId==p.id }"
          >
            <a
              v-if="getSub(p).length"
              @click="activeId=p.id"
              role="button"
              class="nav-link"
              :class="{'active': p.id==$route.params.id }"
            >{{p.task}}</a>

            <router-link
              v-else
              :to="({name: $store.state.app.activeGroup.publicPage.route, params: {id: p.id, cid: 0} })"
              class="nav-link"
              :class="{'active': p.id==$route.params.id }"
            >{{p.task}}</router-link>
            <ul v-if="getSub(p).length" class="navbar-menu-sub">
              <li class="nav-sub-item" v-for="(s,i) in getSub(p)" :key="i">
                <a
                 v-if="s.locTypeCode=='link'"
                  class="nav-sub-link"
                  :href="s.taskEn" target="_blank"
                >
                  <feather type="chevron-right"></feather>
                  {{s.task}}
                </a>
                <router-link
                 v-else
                  class="nav-sub-link"
                  :to="({name: $store.state.app.activeGroup.publicPage.route, params: {id: s.id, cid: 0} })"
                >
                  <feather type="chevron-right"></feather>
                  {{s.task}}
                </router-link>
              </li>
            </ul>
          </li>
        </ul>

        <div v-if="$store.state.app.isMobile" class="mg-x-10">
          <router-link
            :to="{name: 'login'}"
            class="btn btn-outline-primary btn-block d-flex justify-content-center" type="button"
          >
            <feather type="log-in" class="mg-r-5" size="14"></feather>Нэвтрэх
          </router-link>
        </div>

        <div class="navbar-right">
          <router-link :to="{name: 'login'}" class="btn btn-primary text-white d-flex"><feather type="log-in" class="mg-r-5" size="14"></feather>Нэвтрэх</router-link>
        </div>
      </div>
    </header> -->
  </div>
</template>

<script>
// import { request } from "@/api/all";
import { mapActions } from "vuex";
var _ = require("lodash");

export default {
  data() {
    return {
      showMobileNav: false,
      pages: [],
      activeId: null,
      myResBaseUrl: "https://res.gosmart.mn/"
    };
  },
  created() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }
  },
  mounted() {

    this.init();
  },
  methods: {
    ...mapActions(["handleResponsiveLayoutConfig"]),
    mainMenuOpen() {
      let _obj = this.$store.state.app.responsiveLayout;
      _obj.navbarNavShow = true;
      _obj.backdrop.show = true;
      _obj.backdrop.onCloseEvent = 1;
      _obj.backdrop.removeClassName = "navbar-nav-show";
      this.handleResponsiveLayoutConfig(_obj).then(() => {
        this.toggleBodyClass("addClass", "navbar-nav-show");
      });
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    init() {
      this.pages = _.sortBy(
        this.$store.state.app.pages.filter(
          x => x.i2 == 1 && x.i1 == 0 && x.parentId == 0
        ),
        "ord",
        "asc"
      );
    },
    getSub(p) {
      let pages = _.sortBy(
        this.$store.state.app.pages.filter(
          x => x.i2 == 1 && x.i1 == 0 && x.parentId == p.id
        ),
        "ord",
        "asc"
      );
      return pages;
    }
  },
  watch: {
    "$root.$route"() {
      //console.log(newRoute);
      this.activeId = null;
    }
  }
};
</script>
